import { Select2Async } from '@/components/forms/Select2Async';
import { loginOverviewApi, parseLoginValue } from '@/api/services/loginOverview';

// Login autocomplete rendered as a real select2 dropdown (remote search), so it
// matches every other select2 dropdown. On select -> {login, connector}.
export function LoginSearch({
  onSelect,
  placeholder = 'Search login…',
  className,
  value,
  valueLabel,
}: {
  onSelect: (login: number, connector: number, label: string) => void;
  placeholder?: string;
  className?: string;
  // Seeded controlled mode (modal): shows the current login as the selected value.
  value?: string | null;
  valueLabel?: string;
}) {
  if (value !== undefined) {
    return (
      <Select2Async
        className={className}
        placeholder={placeholder}
        value={value}
        valueLabel={valueLabel}
        fetch={(term, page) => loginOverviewApi.searchLogins(term, page)}
        onChange={(v) => {
          if (!v) return;
          const parsed = parseLoginValue(v);
          if (parsed) onSelect(parsed.login, parsed.connector, valueLabel ?? '');
        }}
      />
    );
  }
  return (
    <Select2Async
      className={className}
      placeholder={placeholder}
      clearOnSelect
      fetch={(term, page) => loginOverviewApi.searchLogins(term, page)}
      onSelect={(value, text) => {
        const parsed = parseLoginValue(value);
        if (parsed) onSelect(parsed.login, parsed.connector, text);
      }}
    />
  );
}
